import React from "react";

export const Header = ({block}) => {
  return React.createElement(`h${block.data.level}`, {id: `title-${block.id}`},
    <span dangerouslySetInnerHTML={{__html: block.data.text}}/>)
}